import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';
import Notification from '@ynap/notification';

const bem = new BEMHelper('Panel');

const propTypes = {
    title: PropTypes.string,
    subTitle: PropTypes.string,
    children: PropTypes.node,
    className: PropTypes.string,
    rowLayout: PropTypes.string,
    additionalInfo: PropTypes.string,
};

function Panel({ title, subTitle, children, className, additionalInfo, rowLayout }) {
    const [isRowLayout, setIsRowLayout] = useState();

    useEffect(() => {
        setIsRowLayout(rowLayout);
    }, [rowLayout]);

    return (
        <div className={bem(null, isRowLayout, className)}>
            {title || subTitle ? (
                <div className={bem('header')}>
                    {title ? <h2 className={bem('title')}>{title}</h2> : null}
                    {subTitle ? <div className={bem('subTitle', isRowLayout)}>{subTitle}</div> : null}
                </div>
            ) : null}
            <div className={bem('content')}>
                {additionalInfo ? (
                    <div className={bem('additionalInfo')}>
                        <Notification className={bem('message')} message={additionalInfo} type="info" />
                    </div>
                ) : null}
                {children}
            </div>
        </div>
    );
}

Panel.propTypes = propTypes;

export default Panel;
